const ActionEnum={
    SET_APPLICATION_DATA : "Set Application Data",
    UPDATE_FIRST_HOLDER_DATA :"Update First Holder Data",
    UPDATE_SECOND_HOLDER_DATA :"Update Second Holder Data",
    UPDATE_HOLDER_LIST :"Update Holder List",
    UPDATE_FIRST_HOLDER_WIDGET_LIST :"Update First Holder Widget List",
    UPDATE_SECOND_HOLDER_WIDGET_LIST :"Update Second Holder Widget Widget List",

    UPDATE_FIRST_HOLDER_PERSONAL_INFO_WIDGET :"Update First Holder Personal Info Widget",
    UPDATE_FIRST_HOLDER_NOMINATION_DETAILS_WIDGET : "Update First Holder Nomination Details Widget",
    UPDATE_IS_KYC_PROCESS_COMPLETED :"Update Is Kyc Process Completed"
}


export default ActionEnum;